export const ROOT = 'StepOne/form/typeProperty';

export const FETCH_TYPE_PROPERTY_REQUEST = `${ROOT}/FETCH_TYPE_PROPERTY_REQUEST`;
export const FETCH_TYPE_PROPERTY_FAILURE = `${ROOT}/FETCH_TYPE_PROPERTY_FAILURE`;
export const FETCH_TYPE_PROPERTY_SUCCESS = `${ROOT}/FETCH_TYPE_PROPERTY_SUCCESS`;
